import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Pallets } from '../../../../../../modules/API/Pallets/pallets'
import { IClientsItem } from '../../../../../../modules/API/Defaults/models/customers'
import { RootState } from '../../../../../../../store/reducers/rootReducer'
import { LOAD, LOAD_END } from '../../../../../../../store/actions/actionsTypes'
import { handleNotifications } from '../../../../../../generic/utils/handleNotifications'
import usePalletLookup from '../../shared/hooks/usePalletLookup'
import { buildCustomerPayload } from '../../shared/helpers/palletPayloads'

/** Business logic for the pallet/editcustomer screen: find a pallet, pick a customer, update it. */
const useEditCustomer = () => {
  const dispatch = useDispatch()
  const lookup = usePalletLookup()
  const customerList: IClientsItem[] = useSelector((state: RootState) => state.defaults.clientList.list)
  const [selectedCustomer, setSelectedCustomer] = useState<IClientsItem | null>(null)

  // Prefill the customer from the found pallet (mirrors legacy behaviour).
  useEffect(() => {
    if (!lookup.palletFound) return
    const customer = customerList?.find((item) => item.CustomerID === lookup.palletFound?.CustomerID)
    setSelectedCustomer(customer || null)
  }, [lookup.palletFound, customerList])

  const submit = useCallback(async () => {
    if (!lookup.palletFound || !selectedCustomer) return
    dispatch({ type: LOAD })
    try {
      await Pallets.putCustomerToPallet(Number(lookup.palletNumber), buildCustomerPayload(selectedCustomer))
      handleNotifications('לקוח עודכן בהצלחה', { type: 'success' })
      setSelectedCustomer(null)
      lookup.reset()
    } catch (error) {
      handleNotifications('לקוח לא עודכן', { type: 'error' })
    } finally {
      dispatch({ type: LOAD_END })
    }
  }, [lookup, selectedCustomer, dispatch])

  return {
    ...lookup,
    customerList: customerList ?? [],
    selectedCustomer,
    setSelectedCustomer,
    submit,
    canSubmit: !!lookup.palletFound && !!selectedCustomer,
  }
}

export default useEditCustomer
